"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/TestimonialCarouselComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TestimonialCarouselItemComponent = /** @class */ (function (_super) {
    __extends(TestimonialCarouselItemComponent, _super);
    function TestimonialCarouselItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TestimonialCarouselItemComponent.prototype.render = function () {
        return react_1.default.createElement("div", { className: this.props.IsActive ? 'carousel-item active' : 'carousel-item' },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("article", { className: "testimonial-statement" },
                        react_1.default.createElement("h4", null, this.props.Statement),
                        react_1.default.createElement("p", { className: "author" }, this.props.Author),
                        react_1.default.createElement("p", { className: "organization" }, this.props.Organisation)))));
    };
    return TestimonialCarouselItemComponent;
}(react_1.default.Component));
exports.default = TestimonialCarouselItemComponent;
